// השם שמוצג למשתמש באפליקציה - הכינוי שבחר, ואם אין - השם המלא (אותו כלל
// כמו בפרופיל ובברכה "שלום ..." באפליקציה). השם המלא נשאר זמין בנפרד
export const userFullName = (u) => `${u?.fName ?? ''} ${u?.lName ?? ''}`.trim();

export const userDisplayName = (u) => u?.nickname?.trim() || userFullName(u) || '-';

// השם המלא - רק כשהוא שונה מהשם המוצג (כלומר יש כינוי), להצגה כשורה משנית
export const userSecondaryName = (u) => {
  const full = userFullName(u);
  return full && full !== userDisplayName(u) ? full : '';
};
